/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { cdnUrlConfig } from '../../Utils/atoms';
import { GameKingApi } from '../../Utils/Api/GameKingApi';
import { useLocation } from 'react-router-dom';
import { getDateString, splitQuery } from '../../Shares/CommonUtil';
import { initUnity } from '../../Utils/unityUtil';
import GameKingPrizeWinner from './GameKingPrizeWinner';

const pageSize = 10;

/**
 * 게임의왕좌 2023년 랭킹 리스트 페이지
 */
const GameKing2023Ranking = () => {
	const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}/BigglzEvent`;
	const [datas, setDatas] = useState([]);
	const [popUpTip, setPopUpTip] = useState(false);
	const { search } = useLocation();
	const querys = splitQuery(search);

	const date = querys['date'] ? querys['date'] : ''; // yyyyMM
	const member_se = querys['member_se'] ? querys['member_se'] : 0;
	const { month, firstDayString, lastDayString, resultDateString } =
		getDateString(date);
	const currentDate = new Date();
	const eventEndDate = new Date('2023-08-01 00:00:00'); // 게임의 왕좌 이벤트 종료 날짜

	useEffect(() => {
		initUnity();

		GameKingApi.getGameKingList(pageSize, date, member_se) // 게임의왕좌 월간 점수총합 랭킹 리스트 GET
			.then((response) => {
				const {
					status,
					data: { datas },
				} = response;
				if (status === 200) {
					setDatas(datas);
				}
			});
	}, []);

	function onGameKingTitleImageError(event) {
		event.target.src = `${IMG_URL}/images/gameking/tit_game_default.png`;
	}

	return (
		<>
			<div id='wrap'>
			<div className='container'>
				<div className='content'>
					<div className='game-king End'>
						<div className='visual'>
							<h1>
								<img
									src={`${IMG_URL}/images/gameking/tit_game_default.png`}
									alt='게임의 왕좌 타이틀'
								/>
							</h1>
							<p>
								<imgWW
									src={`${IMG_URL}/images/gameking/img_event_end.png`}
									alt='이벤트 종료 안내'
								/>
							</p>
						</div>
						<div className='copy'>
							<p>
								지금까지 게임의 왕좌에
								<br /> 많은 관심을 보내주셔서 감사해요.
							</p>
							<p>
								아쉽지만, <strong>게임의 왕좌 이벤트는</strong> <br />{' '}
								<strong>잠시 종료</strong>되었음을 알려드려요.
							</p>
							<p>
								비글즈는 더 다양하고 재밌는
								<br /> 이벤트들과 함께 돌아오도록 할게요.
								<br /> 조금만 기다려주세요!
							</p>
						</div>
						<div className='floating'>
							<img
								src={`${IMG_URL}/images/gameking/logo_bigglz_end.png`}
								alt='bigglz'
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		</>
	);
};

export default GameKing2023Ranking;
